import React, { useState } from 'react';
import CollectionsCarousel from '../Landing/CollectionsCarousel';
import CollectionDetailView from '../Collections/CollectionDetailView';
import { imageUrl as blobImageUrl } from '../data/imageUrl';
import useDraftImageUrls from './useDraftImageUrls';
import { GOLD_LT, INK } from '../theme';

export default function PreviewPane({ collection }) {
  const [view, setView] = useState('detail');
  const previewImageUrl = useDraftImageUrls(collection.images, blobImageUrl);

  const tabStyle = (active) => ({
    fontSize: 12,
    letterSpacing: '.12em',
    textTransform: 'uppercase',
    color: active ? INK : GOLD_LT,
    background: active ? GOLD_LT : 'none',
    border: `1px solid ${GOLD_LT}`,
    padding: '8px 14px',
    cursor: 'pointer',
  });

  return (
    <div style={{ border: '1px solid rgba(201,162,75,.3)', position: 'sticky', top: 20 }}>
      <div style={{ display: 'flex', gap: 8, padding: 12, borderBottom: '1px solid rgba(201,162,75,.3)' }}>
        <button onClick={() => setView('carousel')} style={tabStyle(view === 'carousel')}>Landing carousel</button>
        <button onClick={() => setView('detail')} style={tabStyle(view === 'detail')}>Collection page</button>
      </div>
      <div style={{ maxHeight: 700, overflow: 'auto' }}>
        {view === 'carousel' ? (
          <CollectionsCarousel collections={[collection]} imageUrl={previewImageUrl} />
        ) : (
          <CollectionDetailView collection={collection} others={[]} imageUrl={previewImageUrl} />
        )}
      </div>
    </div>
  );
}
